import {icon, button, input} from './tokens/semantic/sizes'
import sizes from './tokens/primitives/sizes'

const themeSizes = {
    size: {
        icon,
        button,
        input,
        ...sizes,
    },
}

export default themeSizes
